import React from 'react'

const AdminMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_4949_40702)"
      fillOpacity="0.1"
    />
    <path
      d="M7.73462 23.9998C7.73462 21.6397 7.73462 19.2504 7.73462 16.8611C10.4153 16.8611 13.0668 16.8611 15.7475 16.8611C15.7475 18.9881 15.7475 21.086 15.7475 23.2422C16.6216 23.2422 17.4666 23.2422 18.3116 23.2422C18.3116 23.5045 18.3116 23.7376 18.3116 23.9998C14.7859 23.9998 11.2603 23.9998 7.73462 23.9998Z"
      fill="#052351"
    />
    <path
      d="M12.688 11.7622C12.7463 10.4801 13.3582 9.25633 14.7276 8.46961C16.3011 7.56634 18.2824 8.00341 19.4479 9.46029C20.73 11.0629 20.6134 13.423 19.1857 14.909C17.3792 16.803 14.2906 16.2785 13.1251 13.9184C12.8337 13.3065 12.688 12.7237 12.688 11.7622Z"
      fill="#052351"
    />
    <path
      d="M20.1764 23.5047C19.7685 23.5629 19.3897 23.6212 19.0109 23.7086C19.0109 23.3298 19.0109 22.9802 19.0109 22.6014C18.1368 22.6014 17.2918 22.6014 16.4468 22.6014C16.4468 20.9697 16.4468 19.3671 16.4468 17.7063C16.5051 17.7354 16.5342 17.7645 16.5925 17.7937C17.2044 17.3275 17.7871 16.8613 18.399 16.3659C18.5156 16.2785 18.603 16.2494 18.7487 16.3077C20.2347 16.7156 21.6333 17.3275 22.7697 18.3764C23.5855 19.134 24.11 20.0373 24.2557 21.1445C24.3139 21.5233 24.11 21.9021 23.7603 22.1061C23.6438 21.4068 23.265 20.9114 22.6531 20.5909C22.1578 20.3578 21.6333 20.3578 21.1379 20.5326C20.1764 20.8531 19.3605 22.1643 20.1764 23.5047Z"
      fill="#052351"
    />
    <path
      d="M23.265 22.3682C23.265 23.1549 22.5949 23.8251 21.8081 23.8251C20.9923 23.8251 20.3513 23.2423 20.3221 22.4265C20.293 21.5815 20.934 20.9113 21.779 20.9113C22.5949 20.8822 23.265 21.5523 23.265 22.3682Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4949_40702"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default AdminMenu
